import React from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { styled  } from '@mui/material'
import { muiColors } from '@zuto/theme/src/mui/DefaultTheme'

interface AnimatedArrowsLargeProps {
  margin?: string
  testId: string
  animationDelays: string[]
}

interface AnimatedArrowWrapperProps {
  margin: string
}

const AnimatedArrowsWrapper = styled('div')<AnimatedArrowWrapperProps>(({ margin }) => ({
  display: 'flex',
  flexDirection: 'row',
  margin: margin
}))

const AnimatedArrowStyles = {
  '@keyframes animate': {
    '0%': {
      opacity: 0,
      transform: 'translate(-15px, 0px)',
      color: '#2e7d32'
    },
    '50%': {
      opacity: 1
    },
    '100%': {
      opacity: 0,
      transform: 'translate(15px, 0px)',
      color: '#D5FFD4'
    }
  },
  animation: 'animate 2s infinite',
  transform: 'translate(-50%, 0%)',
  ml: -3
}

const AnimatedArrowsLarge: React.FC<AnimatedArrowsLargeProps> = ({
  margin = '0 20px',
  testId,
  animationDelays
}) => {
  return (
    <AnimatedArrowsWrapper margin={margin} data-testid={testId}>
      {animationDelays.map((delay, index) => (
        <ArrowForwardIosIcon
          key={index}
          fontSize="medium"
          sx={{
            ...AnimatedArrowStyles,
            fontSize: 35,
            marginBottom: '5px',
            color: muiColors.primary.successGreen
          }}
          style={{ animationDelay: delay }} 
        />
      ))}
    </AnimatedArrowsWrapper>
  )
}

export default AnimatedArrowsLarge
